"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
require("@ali/dingtalk-jsapi/entry/union");
var ddm_data_pipe_1 = require("@ali/ddm-data-pipe");
var index_1 = tslib_1.__importDefault(require("@ali/ddm-trace-sdk/es/index"));
var init = function () {
    // 通信库挂载winodw变量
    window.DDMStore = ddm_data_pipe_1.DDMStore;
    window.DDMEvent = ddm_data_pipe_1.DDMEvent;
    // 初始化打点sdk
    index_1.default.initTrace();
};
init();
exports.default = {
    init: init,
};
